import {makeAutoObservable} from "mobx";
import * as SettingsProvider from '../../services/settings';
import * as PubSub from '../pubSub';
import {Manager} from "../../core";

export class SettingsStoreMobx {
	public list: any[] = [];
	protected provider = SettingsProvider;

	constructor() {
		makeAutoObservable(this);
	}

	get = async () => {
		try {
			const {data}: any = await this.provider.get();
			this.setList(data);
			return data;
		} catch (err) {
			throw new Manager.ServiceError('error.settingsStore.get', err);
		}
	}

	update = async (payload: any) => {
		try {
			const {data}: any = await this.provider.update(payload);
			await this.get();
			return data;
		} catch (err) {
			throw new Manager.ServiceError('error.settingsStore.update', err);
		}
	}

	setList = (list: any[]) => {
		this.list = list;
	}
}

let singleton: SettingsStoreMobx | null;

export const SettingsStore = () => {
	if (!singleton) {
		singleton = new SettingsStoreMobx();

		PubSub.subscribe(PubSub.LOGOUT, () => {
			singleton = null;
		});
	}
	return singleton;
};
